import React, { memo } from "react";
import Pagination from "@material-ui/lab/Pagination";
import { TableContainer, Paper, TableRow } from "@material-ui/core";
import { Table, TableBody, TableCell, TableHead } from "@material-ui/core";
// component
import Loader from "components/loader/Loader";
import { MyCheckbox } from "components/MyCheckbox";

const RenewalTableListing = ({
  setPage,
  sortCharged,
  count,
  page,
  productData = [],
  loading,
  selectedData = [],
  onCheckboxClick,
  onSelectAllClick,
  itemsPerPage = 50,
  fetchWithDelay,
  activeFilterBody = {},
}) => {
  return (
    <div className="w-100">
      <div className="family-table-container pl-13 pr-2 pb-15 pr-13">
        <div
          className="home-table-container mt-0 no-box-shadow"
          style={{
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            padding: 20,
            borderRadius: 12,
          }}
        >
          <div className="d-flex justify-content-between h-40px">
            <div className="yah-sub">
              {selectedData?.includes("all") ? count : selectedData?.length}{" "}
              Accounts selected
            </div>
          </div>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <MyCheckbox
                      handlechange={(e) => onSelectAllClick(e, productData)}
                      checked={selectedData?.includes("all")}
                    />
                  </TableCell>
                  <TableCell onClick={() => sortCharged("name")}>
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#4d5565",
                      }}
                    >
                      {"Account Name".toUpperCase()}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#4d5565",
                      }}
                    >
                      {"billing type".toUpperCase()}
                    </span>
                  </TableCell>
                </TableRow>
              </TableHead>

              {loading && (
                <div className="tran-loader">
                  <Loader />
                </div>
              )}

              {productData?.length === 0 ? (
                <td colSpan={12}>
                  <div className="record-text">No record found</div>
                </td>
              ) : (
                !loading &&
                productData?.map((row) => (
                  <TableBody key={row._id}>
                    <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                      <TableCell padding="checkbox">
                        <MyCheckbox
                          handlechange={(e) => onCheckboxClick(e, row)}
                          checked={
                            selectedData?.includes("all") ||
                            selectedData?.includes(row._id)
                          }
                        />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <div
                          className="sub title-name"
                          style={{ fontWeight: 400, fontSize: 12 }}
                        >
                          {row?.name ?? row?.family_name}
                        </div>
                      </TableCell>

                      <TableCell align="left">
                        <div
                          className="sub"
                          style={{ fontWeight: 400, fontSize: 12 }}
                        >
                          {row?.payment?.billing_type?.title ?? "-"}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ))
              )}
            </Table>
          </TableContainer>
          {productData?.length > 0 && (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / itemsPerPage)}
                page={page}
                color="primary"
                variant="outlined"
                onChange={(event, value) => {
                  fetchWithDelay(value, activeFilterBody);
                  setPage(value);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(RenewalTableListing);
